import Header from "../components/Header";
import React, {Suspense, useState} from "react";
import {Fancybox} from "@fancyapps/ui/dist/fancybox.esm";
import {HeaderPacer} from "../components/header/types/HeaderPacer";
import {FooterWrapper} from "../components/FooterWrapper";
import {LoaderComponent} from "../components/header/types/LoaderComponent";
import {useSelector} from "react-redux";
import {MainLayoutSkeleton} from "../components/header/types/MainLayoutSkeleton";
import BodyEndSectionsWrapper from "../components/BodyEndSectionsWrapper";
import InlineStyles from "../components/templates/index/partials/InlineStyles";


export default function MainLayout(props) {

    const [urlHref, setUrlHref] = useState(null);

    const app = props.app;

    const rgbDesignColor = props.rgbDesignColor;

    const rgbSearchbarColor = props.rgbSearchbarColor;

    React.useEffect(() => {
        Fancybox.bind("[data-fancybox]", {
            Image: {
                zoom: false,
            },
            Hash: false,
        });
        if (window !== undefined) {
            setUrlHref(window.location.href + '/');
        }
    }, [urlHref]);

    const mainPacer = useSelector(state => state['uiData']['mainPacer'])

    const disablePacer = false

    return (
        <>
            <InlineStyles app={app} rgbDesignColor={rgbDesignColor} rgbSearchbarColor={rgbSearchbarColor}/>
            <Header referer={urlHref} {...props} />
            <HeaderPacer />
            <LoaderComponent />

            {
                (!mainPacer || disablePacer) ?
                    props.children
                    :
                    <MainLayoutSkeleton />
            }
            <FooterWrapper {...props} />
            <BodyEndSectionsWrapper />
        </>
    )
}